import { Link } from "react-router-dom";
import { SITE } from "@/constants/site";
import { cn } from "@/lib/utils";

// The provided brand asset already contains the full "Halal GO" wordmark, so we
// present it as a self-contained square badge (no duplicate text label).
export const Logo = ({ className = "", size = "md", withLink = true }) => {
  const sizes = { sm: "h-9 w-9", md: "h-11 w-11", lg: "h-12 w-12" };
  const img = (
    <img
      src={SITE.logo}
      alt="Halal GO logo"
      className={cn(
        "rounded-lg object-cover ring-1 ring-halalgo-kraft-200 shadow-sm",
        sizes[size] || sizes.md
      )}
      width={48}
      height={48}
    />
  );

  if (!withLink) return <span className={cn("inline-flex items-center", className)}>{img}</span>;

  return (
    <Link
      to="/"
      aria-label="Halal GO home"
      data-testid="brand-logo-link"
      className={cn("inline-flex items-center rounded-lg", className)}
    >
      {img}
    </Link>
  );
};
